import { useDocFlowContext } from '../../DocFlow.hooks'
import { ArchiveButton } from '../ArchiveButton'
import { NextPhaseButton } from '../NextPhaseButton'
import { RestoreButton } from '../RestoreButton'

import * as styles from './DocFlowProfileHeaderActionsBase.module.css'

function DocFlowProfileHeaderActionsBase({
  archiveButtonProps,
  children,
  isResultPhase,
  nextButtonProps,
  ...restProps
}) {
  const { docFlow } = useDocFlowContext()

  return (
    <>
      {docFlow.archived ? (
        <RestoreButton {...restProps} />
      ) : (
        <>
          {!isResultPhase ? (
            <NextPhaseButton {...restProps} {...nextButtonProps} />
          ) : null}
          <ArchiveButton
            {...restProps}
            {...archiveButtonProps}
            className={styles.archive}
          />
          {children}
        </>
      )}
    </>
  )
}

export default DocFlowProfileHeaderActionsBase
